/**
 * #handler.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Empty } from "../../../google/protobuf/empty.js";
import { ScheduledAction } from "./action.js";
export const SchedulerHandlerServiceName = "devvit.actor.scheduler.SchedulerHandler";
export class SchedulerHandlerClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || SchedulerHandlerServiceName;
        this.rpc = rpc;
        this.HandleScheduledAction = this.HandleScheduledAction.bind(this);
    }
    HandleScheduledAction(request, metadata) {
        const data = ScheduledAction.encode(request).finish();
        const promise = this.rpc.request(this.service, "HandleScheduledAction", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
}
export const SchedulerHandlerDefinition = {
    name: "SchedulerHandler",
    fullName: "devvit.actor.scheduler.SchedulerHandler",
    methods: {
        handleScheduledAction: {
            name: "HandleScheduledAction",
            requestType: ScheduledAction,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {},
        },
    },
};
